const getDateOfBirth = (expressCheckoutData)=>{
    if (!expressCheckoutData) {
        return null;
    }
    const expressCheckoutForm = expressCheckoutData.formData['express-checkout-dob'];
    if (expressCheckoutForm && expressCheckoutForm.value && expressCheckoutForm.value !== '') {
        return expressCheckoutForm.value;
    }
    return null;
};

export { getDateOfBirth };
//# sourceMappingURL=apple-pay-date-of-birth.js.map
